import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Breadcrumbs } from "./E-BooksComponent";
import "../Styles/AudioLanding.css";

const AudioLandingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Breadcrumbs
        mainsubBreadCrumb={t("Audios_tr")}
        subBreadCrumb={t("Home_tr")}
        navigatemainsubBreadCrumb={() => navigate("/")}
        subBreadCrumbTwo={t("Audios_tr")}
        navigatesubBreadCrumb={() => {}}
      />

      <div className="audio-landing-section">
        <header className="audio-landing-hero">
          <h1 className="audio-landing-hero-title">Divine Audio</h1>
          <p className="audio-landing-hero-subtitle">Listen to the wisdom of Gita</p>
        </header>

        <div className="audio-landing-grid">
          <div className="audio-landing-card">
            <div className="audio-landing-card-image audio-landing-card-image-gita" />
            <div className="audio-landing-card-body">
              <h2 className="audio-landing-card-title">Bhagavad Gita</h2>
              <p className="audio-landing-card-desc">Chapter-wise recitations</p>
              <button
                type="button"
                className="audio-landing-card-btn"
                onClick={() => navigate("/audios")}
              >
                Listen Now
              </button>
            </div>
          </div>

          <div className="audio-landing-card">
            <div className="audio-landing-card-image audio-landing-card-image-bhajan" />
            <div className="audio-landing-card-body">
              <h2 className="audio-landing-card-title">Bhajans & Kirtans</h2>
              <p className="audio-landing-card-desc">Devotional songs</p>
              <button
                type="button"
                className="audio-landing-card-btn"
                onClick={() => navigate("/audios")}
              >
                Play
              </button>
            </div>
          </div>

          <div className="audio-landing-card">
            <div className="audio-landing-card-image audio-landing-card-image-discourse" />
            <div className="audio-landing-card-body">
              <h2 className="audio-landing-card-title">Spiritual Discourses</h2>
              <p className="audio-landing-card-desc">Talks by saints</p>
              <button
                type="button"
                className="audio-landing-card-btn"
                onClick={() => navigate("/pravachans")}
              >
                Explore
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AudioLandingPage;
